export default "__VITE_ASSET__BuJlV2zc__"